import { createFileRoute } from '@tanstack/react-router';
import { AssessmentOverviewPage } from '@/pages/assessment/ui/AssessmentOverviewPage';

export const Route = createFileRoute('/_protected/assessment/$assessmentId/overview/')({
  component: AssessmentOverviewPage,
});
